import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import LoadingDialog from "../../components/loadingDialog";
import {campusDelete} from "./programSetService";

export default function ProgramSetCampusDelete(params: {programSetId: number, campus: any, setCampus: any, reload: any}) {
    const [loading, setLoading] = React.useState(false);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason === "backdropClick")
            return;
        params.setCampus(null);
    };

    const handleSubmit = async () => {
        setLoading(true);
        const good = await campusDelete(params.programSetId, params.campus.name);

        if (good) {
            toast.success('Campus permanently removed');
            setLoading(false);
            handleClose();
            params.reload();
        } else {
            setLoading(false);
        }
    }

    if (!params.campus) return <> </>;

    return (
        <Dialog
            open={!!params.campus}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth={true}
        >
            <DialogTitle>Perma-Delete Campus</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to permanently remove {params.campus.name}? There is no going back after this.
                </DialogContentText>
            </DialogContent>
            {loading ? <LoadingDialog/> :
                <DialogActions>
                    <Button sx={{color: 'green'}} onClick={handleClose}>Cancel</Button>
                    <Button sx={{color: 'red'}} onClick={handleSubmit} autoFocus>Perma-Delete</Button>
                </DialogActions>
            }
        </Dialog>
    )
}
